import { toast } from "react-toastify"

export const clearNotifications = () => {
	return toast.dismiss()
}